import { FONT_SECONDARY } from "@/theme/typography";
import { Theme } from "@mui/material";

export const getListItemStyles = (theme: Theme, isCartPage: boolean) => ({
  borderBottom: !isCartPage ? `1px solid ${theme.palette.grey[200]}` : "",
  paddingBottom: !isCartPage ? 2 : 3,

  "&:not(:first-of-type)": {
    paddingTop: !isCartPage ? 2 : 3,
  },

  "&:not(:last-of-type)": {
    borderBottom: isCartPage ? `1px solid ${theme.palette.grey[200]}` : "",
  },
});

export const emptyCartWrapperStyles = {
  width: "100%",
  pt: 3.75,
  pb: 4.25,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "& svg": {
    stroke: "#CECECE",
    width: "100px",
    height: "auto",
  },
};

export const getCartNotificationLinkStyles = (isCartPage: boolean) => ({
  fontFamily: FONT_SECONDARY,
  padding: !isCartPage ? 0 : 2,

  "&:hover": {
    color: "primary.dark",
  },
  "&:focus": {
    color: "primary.dark",
  },
});

export const cartNotificationButtonStyles = {
  padding: 2,
  bgcolor: "transparent",

  "&:hover": {
    bgcolor: "transparent",
    color: "primary.dark",
  },
  "&:focus": {
    bgcolor: "transparent",
    color: "primary.dark",
  },
};

export const linkStyles = { fontWeight: 600, fontFamily: FONT_SECONDARY };
